// js/haptics.js
// Web‑safe haptics fallback (Capacitor removed)

function vibrateFallback(ms) {
    if (navigator.vibrate) navigator.vibrate(ms);
}

/** Light tap — for toggles, menu opens */
export async function hapticLight() {
    vibrateFallback(30);
}

/** Medium impact — for play/pause, skip */
export async function hapticMedium() {
    vibrateFallback(50);
}

/** Success notification — for like/unlike, add to queue */
export async function hapticSuccess() {
    vibrateFallback(40);
}

/** Long press — replaces navigator.vibrate(50) for track selection */
export async function hapticLongPress() {
    vibrateFallback(50);
}
